import { styled } from "@mui/material/styles";
import { Box, Typography } from "@mui/material";

export const VerificationContainer = styled(Box)(() => ({
  width: "100%",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
}));

export const VerificationTitle = styled(Typography)(() => ({
  fontSize: "26px",
  fontStyle: "normal",
  fontWeight: 600,
  textAlign: "center",
  marginBottom: "16px",
}));

export const VerificationSubtitle = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.secondary,
  textAlign: "center",
  fontFamily: "Nunito",
  fontSize: "18px",
  fontStyle: "normal",
  fontWeight: 700,
  lineHeight: "32px",
  marginBottom: "44px",
}));

export const VerificationForm = styled(Box)(() => ({
  width: "100%",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: "28px",
}));

export const VerificationResend = styled(Box)(({ theme }) => ({
  textAlign: "center",
  color: theme.palette.text.secondary,
  fontSize: "16px",
  fontFamily: "Nunito",
  fontWeight: 700,
  lineHeight: "20px",
  minWidth: "auto",
  "& button": {
    padding: 0,
    height: "auto",
  },
}));

export const VerificationActions = styled(Box)(() => ({
  display: "flex",
  justifyContent: "center",
  gap: "24px",
  alignItems: "center",
  marginTop: "16px",
}));

export const VerificationBackupLink = styled(Box)(() => ({
  textAlign: "center",
  marginTop: "10px",
  "& button": {
    minWidth: "auto",
    padding: 0,
    textTransform: "none",
    fontSize: "16px",
    color: "primary.main",
    height: "auto",
    fontWeight: 600,
  },
}));
